import React, { useState } from "react";
import { BsFillCameraVideoFill, BsBoxArrowInUpRight } from "react-icons/bs";
import { Table } from "react-bootstrap";
import {
    replaceSearchedText,
    containsSearchText,
} from "../utils/highlightSearchText";
import { useTranslation } from "react-i18next";

const SearchModalContagemTabBody = ({ layerData, myMap, cityID }) => {
    const sortedData = layerData.sort(
        (a, b) =>
            a.properties.OINTERSECAONUMERO - b.properties.OINTERSECAONUMERO
    );
    const [searchText, setSearchText] = useState("");
    const searchHandler = (e) => {
        setSearchText(e.target.value);
        if (e.target.value) {
            setSearchText(e.target.value);
        }
    };
    const { t } = useTranslation("searchModalTab_cont");

    const layerTbTitles = [<BsFillCameraVideoFill />, t("cont"), t("docs")];

    const layerDataList = sortedData
        .filter(
            (int) =>
                searchText === "" ||
                containsSearchText(
                    int.properties.OINTERSECAONUMERO,
                    searchText
                ) ||
                containsSearchText(
                    int.properties.OINTERSECAOSITUACAO,
                    searchText
                ) ||
                containsSearchText(int.properties.OENDLOCALP, searchText) ||
                containsSearchText(int.properties.OENDLOCALT, searchText) ||
                containsSearchText(int.properties.OENDLOCALS, searchText) ||
                containsSearchText(int.properties.OSUBREDE, searchText) ||
                containsSearchText(int.properties.OINTERLIGACAO, searchText) ||
                containsSearchText(int.properties.OCTRL, searchText)
        )
        .map((cont, index) => {
            const featureNum = replaceSearchedText(
                cont.properties.OINTERSECAONUMERO,
                searchText
            );
            const logradouro = [
                cont.properties.OENDLOCALP,
                cont.properties.OENDLOCALS,
                cont.properties.OENDLOCALT,
            ]
                .filter((e) => e !== "")
                .flatMap((e, i) => [
                    <span key={2 * i}>
                        {replaceSearchedText(e, searchText)}
                    </span>,
                    <br key={2 * i + 1} />,
                ])
                .slice(0, -1);

            const setViewToCont = () => {
                myMap.setView(
                    [
                        cont.geometry.coordinates[1],
                        cont.geometry.coordinates[0],
                    ],
                    20
                );
            };

            return (
                <tr
                    className="search-modal-table-content"
                    key={index}
                    onClick={setViewToCont}
                >
                    <td>{featureNum}</td>
                    <td className="search-modal-table-align-left ">
                        {logradouro}
                    </td>
                    <td>
                        <a
                            href={`/docs/interseccaoContOD/${featureNum}/${cityID}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <BsBoxArrowInUpRight />
                        </a>
                    </td>
                </tr>
            );
        });

    return (
        <div
            className="tab-pane fade"
            id="cont"
            role="tabpanel"
            aria-labelledby="cont-tab"
        >
            <input
                type="text"
                className="igu-searchModal-input form-control"
                name="search"
                onChange={searchHandler}
                value={searchText}
                placeholder={t("search_cont")}
                aria-label={t("search_cont")}
                aria-describedby="basic-addon2"
            />
            <Table striped hover>
                <thead>
                    <tr className="search-modal-table-header">
                        {layerTbTitles.map((layer, i) => (
                            <th
                                className="search-modal-table-header-names"
                                key={i}
                            >
                                {layer}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>{layerDataList}</tbody>
            </Table>
        </div>
    );
};

export default SearchModalContagemTabBody;
